module.exports = __webpack_public_path__ + "img/article-header-preview-2.2b398078.jpg";